export const ATTENDEE_STATUS_INCOMPLETE = "Incomplete";

export const PRINT_APP_HIDE_FIND_TICKET_BY_FULLNAME = "PRINT_APP_HIDE_FIND_TICKET_BY_FULLNAME";
export const PRINT_APP_HIDE_FIND_TICKET_BY_EMAIL = "PRINT_APP_HIDE_FIND_TICKET_BY_EMAIL";

export const BADGE_FEATURE_NOT_FOUND = "The badge specifies a feature that is missing from the local summit data.";